// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"34128649","80":"3383140e","105":"906e1d18","174":"404d1674","256":"9ce6a15d","310":"80389459","379":"b75ae8a8","434":"a64053eb","557":"ab1dd8ba","770":"b895083c","872":"5653bbf3"}[chunkId] + ".chunk.js";
};